import { createAsyncThunk } from '@reduxjs/toolkit';
import tagApi from '~/apis/tag';
import { GET_TAGS } from '~/utils/constants/actionType';
import { IResponseGetTags } from '~/utils/interface/tag';

export const handleGetTags = createAsyncThunk<IResponseGetTags>(
  GET_TAGS,
  async (_params, { rejectWithValue }) => {
    try {
      const res = await tagApi.getTags();

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
